
  <div class="container-fluid">
    <!-- Start page title -->
    <!-- <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between" style="background-color: #B71C1C; padding: 1rem; border-radius: 0.375rem; margin-bottom: 1.5rem;">
          <h4 class="mb-sm-0" style="color: white;">Report Incident</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" style="color: rgba(255, 255, 255, 0.8);">Incidents</a></li>
              <li class="breadcrumb-item active" style="color: white;">Report Incident</li>
            </ol>
          </div>
        </div>
      </div>
    </div> -->
    <!-- End page title -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header" style="background-color: #B71C1C; color: white;">
            <h4 class="card-title mb-0" style="color: white;">{{ 'INCIDENTS.INCIDENTINTAKEFORM' | translate }}</h4>
          </div>
          <div class="card-body"  *ngIf="roleService.hasRole(['admin'])">
            <form [formGroup]="incidentForm" (ngSubmit)="onSubmit()">
              <div class="row" >
                <!-- Contact Information -->
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="contactName" class="form-label">{{ 'INCIDENTS.CONTACTNAME' | translate }} <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="contactName" formControlName="contactName" 
                           [ngClass]="{ 'is-invalid': submitted && f['contactName'].errors }" 
                           [placeholder]="'INCIDENTS.ENTERCONTACTNAME' | translate">
                    <div *ngIf="submitted && f['contactName'].errors" class="invalid-feedback">
                      <div *ngIf="f['contactName'].errors['required']">{{ 'INCIDENTS.CONTACTNAME' | translate }} {{ 'INCIDENTS.ISREQUIRED' | translate }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="contactNumber" class="form-label">{{ 'INCIDENTS.CONTACTNUMBER' | translate }} <span class="text-danger">*</span></label>
                    <input type="tel" class="form-control" id="contactNumber" formControlName="contactNumber" 
                           [ngClass]="{ 'is-invalid': submitted && f['contactNumber'].errors }" 
                           [placeholder]="'INCIDENTS.ENTER10DIGIT' | translate">
                    <div *ngIf="submitted && f['contactNumber'].errors" class="invalid-feedback">
                      <div *ngIf="f['contactNumber'].errors['required']">{{ 'INCIDENTS.CONTACTNUMBER' | translate }} {{ 'INCIDENTS.ISREQUIRED' | translate }}</div>
                      <div *ngIf="f['contactNumber'].errors['pattern']">{{ 'INCIDENTS.PLEASEENTER10DIGIT' | translate }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- Location Information -->
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="location" class="form-label">{{ 'INCIDENTS.LOCATION' | translate }} <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="location" #locationInput formControlName="location" 
                           [ngClass]="{ 'is-invalid': submitted && f['location'].errors }" 
                           [placeholder]="'INCIDENTS.ADDRESSSUGGESTIONS' | translate" autocomplete="off">
                    <small class="text-muted">{{ 'INCIDENTS.TYPEADDRESS' | translate }}</small>
                    <div *ngIf="submitted && f['location'].errors" class="invalid-feedback">
                      <div *ngIf="f['location'].errors['required']">{{ 'INCIDENTS.LOCATION' | translate }} {{ 'INCIDENTS.ISREQUIRED' | translate }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="landmark" class="form-label">{{ 'INCIDENTS.LANDMARK' | translate }}</label>
                    <input type="text" class="form-control" id="landmark" formControlName="landmark" 
                           [placeholder]="'INCIDENTS.ENTERLANDMARK' | translate">
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- Geographic Information -->
                
               
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="severityId" class="form-label">{{ 'INCIDENTS.SEVERITYLEVEL' | translate }} <span class="text-danger">*</span></label>
                    <select class="form-select" id="severityId" formControlName="severityId" 
                            [ngClass]="{ 'is-invalid': submitted && f['severityId'].errors }">
                      <option value="" disabled>{{ 'INCIDENTS.SELECTSEVERITY' | translate }}</option>
                      <option *ngFor="let severity of severities" [value]="severity.id">
                        {{'INCIDENTS.' + (severity.name | uppercase )| translate }}
                      </option>
                    </select>
                    <div *ngIf="submitted && f['severityId'].errors" class="invalid-feedback">
                      <div *ngIf="f['severityId'].errors['required']">{{ 'INCIDENTS.SEVERITYLEVEL' | translate }} {{ 'INCIDENTS.ISREQUIRED' | translate }}</div>
                    </div>
                  </div>
                </div>
              </div>


              <!-- Remarks -->
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="remarks" class="form-label">{{ 'INCIDENTS.INCIDENTDETAILS' | translate }}</label>
                    <textarea class="form-control" id="remarks" formControlName="remarks" rows="4" 
                              [placeholder]="'INCIDENTS.PROVIDEDESCRIPTION' | translate"></textarea>
                    
                  </div>
                </div>
              </div>

              <!-- Form Actions -->
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-secondary" (click)="resetForm()" [disabled]="loading">
                      <i class="ri-refresh-line me-1"></i> {{ 'INCIDENTS.RESET' | translate }}
                    </button>
                    <button type="submit" class="btn btn-primary" [disabled]="loading">
                      <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                      <i *ngIf="!loading" class="ri-send-plane-line me-1"></i>
                      {{ loading ? ('INCIDENTS.SUBMITTING' | translate) : ('INCIDENTS.REPORTINCIDENT' | translate) }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
